import { SET_DATA_LIST } from "../actions";

export const INIT_STATE = {
  postalCodes: [],
  procedures: [],
  branches: [],
  users: [],
};

export const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_DATA_LIST:
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};
